import React, { memo, useMemo, useState } from 'react';

import { FilterGroup } from '@/components/Filter/types';
import { Filter } from '@/components/FilterManager';

import useTagOptions from '../../../hooks/useTagOptions';
import { MultiSelectValues } from '../../../types';
import { TagsValueSelectorProps } from '../types';

function MultiSelectComp(props: TagsValueSelectorProps & { toggle: () => void }) {
  const { tag, selectedTagValue, onChange, children, filters, toggle } = props;
  const { id } = tag;

  const [searchText, setSearchText] = useState('');
  const {
    error: tagOptionFetchingError,
    tagOptions,
    fetchMore,
    fetching,
    isFetchingMore,
  } = useTagOptions({
    tagId: id,
    valueText: searchText,
    parentId: filters?.parentId,
    valueIds: filters?.valueIds,
  });

  const multiSelectTagValue = selectedTagValue as MultiSelectValues;
  const groups: FilterGroup[] = useMemo(() => {
    if (filters?.valueIds && filters?.valueIds.length === 0) {
      return [];
    }

    return tagOptions?.length
      ? [
          {
            id: tag.id,
            options: tagOptions?.map((option) => ({
              value: option.id,
              label: option.name,
            })),
          },
        ]
      : [];
  }, [filters?.valueIds, tagOptions, tag.id]);

  const selectedValues = multiSelectTagValue || [];

  return (
    <Filter
      isGroupSelectionEnabled
      open
      asyncOptions={{
        search: {
          value: searchText,
          onChange: setSearchText,
        },
        fetchMore,
        fetching: fetching || isFetchingMore,
        error: !!tagOptionFetchingError,
      }}
      groups={groups}
      showActionButtons={false}
      value={selectedValues}
      onChange={onChange}
      onToggle={toggle}>
      {children}
    </Filter>
  );
}

export default memo(MultiSelectComp);
